import moment from "jalali-moment";

export const truncateString = (string, length) => {
  return string.length > length ? `${string.substring(0, length)} ...` : string;
};

export const formatDate = (date, format, locale) => {
  return moment(date).locale(locale).format(format);
};

export const formatTime = (date, locale) => {
  return moment(date).format("HH:mm").toString();
};

export const isEmpty = data => {
  const type = Object.prototype.toString.call(data);
  if (type === "[object Object]") {
    return Object.keys(data).length === 0;
  }
  if (type === "[object Array]") {
    return data.length === 0;
  }

  return true;

  //Object  // [object Object]
  //Array  // [object Array]
  //String  // [object String]
};

export const getImageUrl = (formats, size) => {
  if (!formats) {
    return null;
  }

  const type = Object.prototype.toString.call(size);
  const keys = Object.keys(formats);

  if (type === "[object String]") {
    if (keys.includes(size)) return formats[size];
  }

  if (type === "[object Array]") {
    const unknownSize = size.filter(item => keys.some(x => x === item));
    if (!!unknownSize.length) {
      return formats[unknownSize[0]];
    }
  }

  return formats["small"] || formats["thumbnail"];
};

export const NextImgCustomLoader = ({ src, width, quality }) => {
  return `${src}?w=${width}&q=${quality || 75}`;
};
